import HomeNavigation from "../../components/Common/HomeNavigation";
import PageTitle from "../../components/Common/PageTitle";
import ChangePassword from "../../components/Account/ChangePassword";
import UserDetails from "../../components/Account/UserDetails";
import DeleteAccount from "../../components/Account/DeleteAccount";
import Discord from "../../components/Account/Discord";
import HE80NameOnWebsite from "../../components/Account/NameOnWebsite";
import { useState } from "react";
import useWootingUser from "../../utils/hooks/useWootingUser";
import { callAPI } from "../../utils/api";
import { useErrorToast, useSuccessToast } from "../../utils/showToast";
import ChangeEmail from "../../components/Account/ChangeEmail";
import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { Trans } from "@lingui/react/macro";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Flex,
  Heading,
  VStack,
} from "@wootingkb/component-library";
import {
  RegionalInstanceCapability,
  useRegionalInstanceCapability,
} from "../../lib/[services]/regional-instance";
import { useUser } from "../../controllers/UserController";
import { ReplaceableKey } from "../../lib/helper/stringReplacer";
import RegionawareLink from "../../components/Common/RegionawareLink";

const YOUR_ACCOUNT_TEXT = msg({
  id: "User_your_account_text",
  message: "Your Account",
});

const REQUEST_DATA_AUTH_ERROR_TEXT = msg({
  id: "User_error_log_in_text",
  message: "You must be logged in to request your data",
});

const REQUEST_DATA_GENERIC_ERROR_TEXT = msg({
  id: "User_error_request_data_text",
  message:
    "There was an error requesting your personal data. Please try again.",
});

const REQUEST_DATA_SUCCESS_TEXT = msg({
  id: "User_success_request_data_text",
  message: "Your personal data package has been sent to your email",
});

export default function Index() {
  const [userDataLoading, setUserDataLoading] = useState(false);
  const [wootingUser] = useWootingUser();
  const { data: user } = useUser();
  const showErrorToast = useErrorToast();
  const showSuccessToast = useSuccessToast();
  const { _: i18n } = useLingui();
  const showDiscordUI = useRegionalInstanceCapability(
    RegionalInstanceCapability.Discord
  );

  const showEmaiPasswordFunctions = user?.phoneNumber == undefined;
  const showGDPRRequestFunction = user?.phoneNumber == undefined;

  async function requestUserData() {
    setUserDataLoading(true);
    try {
      if (!wootingUser) {
        showErrorToast(i18n(REQUEST_DATA_AUTH_ERROR_TEXT));
        return;
      }

      await callAPI(["gdpr", "dataPackage"], {
        isAuthd: true,
        method: "POST",
      });

      showSuccessToast(i18n(REQUEST_DATA_SUCCESS_TEXT));
    } catch (error) {
      showErrorToast(i18n(REQUEST_DATA_GENERIC_ERROR_TEXT));
    } finally {
      setUserDataLoading(false);
    }
  }

  return (
    <>
      {/* Page title */}
      <PageTitle title={i18n(YOUR_ACCOUNT_TEXT)} />
      <HomeNavigation />
      <VStack className="gap-4 xl:gap-16">
        <Flex className="gap-4 xl:flex-row xl:gap-16">
          <UserDetails />
          <VStack className="gap-4">
            {showDiscordUI && <Discord />}
            {wootingUser?.name_on_website && (
              <HE80NameOnWebsite nameOnWebsite={wootingUser.name_on_website} />
            )}
            {showEmaiPasswordFunctions && (
              <>
                <ChangePassword />
                <ChangeEmail />
              </>
            )}
          </VStack>
        </Flex>

        <Card>
          <CardHeader>
            <Heading as="h3" size="h4" weight="semibold">
              <Trans id="User_other_section_title">Other</Trans>
            </Heading>
          </CardHeader>
          <CardContent className="flex gap-4 md:flex-row md:justify-between">
            <RegionawareLink
              href={`${ReplaceableKey.WootingStoreURL}/policies/privacy-policy`}
              variant="underline"
              className="text-foreground-accent-primary"
              external
            >
              <Trans id="PrivacyPolicy_Text">Privacy Policy</Trans>
            </RegionawareLink>
            <Flex className="gap-4 md:flex-row">
              {showGDPRRequestFunction && (
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={requestUserData}
                  isLoading={userDataLoading}
                >
                  <Trans id="User_request_personal_data">
                    Request personal data
                  </Trans>
                </Button>
              )}
              <DeleteAccount />
            </Flex>
          </CardContent>
        </Card>
      </VStack>
    </>
  );
}
